export type TaxStateCode = 'DE' | 'MT' | 'NH' | 'OR' | 'AK';

export interface TaxState {
  code: TaxStateCode;
  name: { zh: string; en: string };
  localTaxPossible: boolean;
  sourceUrl: string;
}

export const taxStates: readonly TaxState[] = [
  {
    code: 'DE',
    name: { zh: '特拉华州', en: 'Delaware' },
    localTaxPossible: false,
    sourceUrl: 'https://revenue.delaware.gov/business-tax-forms/doing-business-in-delaware/step-4-gross-receipts-taxes/',
  },
  {
    code: 'MT',
    name: { zh: '蒙大拿州', en: 'Montana' },
    localTaxPossible: false,
    sourceUrl: 'https://mtrevenue.gov/wp-content/uploads/2017/07/2014-Biennial-Report.pdf',
  },
  {
    code: 'NH',
    name: { zh: '新罕布什尔州', en: 'New Hampshire' },
    localTaxPossible: false,
    sourceUrl: 'https://www.revenue.nh.gov/faq/does-new-hampshire-have-sales-tax',
  },
  {
    code: 'OR',
    name: { zh: '俄勒冈州', en: 'Oregon' },
    localTaxPossible: false,
    sourceUrl: 'https://www.oregon.gov/dor/programs/businesses/Pages/sales-tax.aspx',
  },
  {
    code: 'AK',
    name: { zh: '阿拉斯加州', en: 'Alaska' },
    localTaxPossible: true,
    sourceUrl: 'https://www.commerce.alaska.gov/web/dcra/OfficeoftheStateAssessor/AlaskaSalesTaxInformation',
  },
] as const;

export const platformTaxSources = [
  {
    label: { zh: 'Apple：付款、定价与税费', en: 'Apple: Payment, pricing, and taxes' },
    url: 'https://www.apple.com/us-edu/shop/help/payments',
  },
  {
    label: { zh: 'Steam 客服：账单信息与销售税', en: 'Steam Support: Billing information and sales tax' },
    url: 'https://help.steampowered.com/en/faqs/view/54EA-F51E-A18E-ED99',
  },
  {
    label: { zh: 'Steam 订户协议：税费与地区限制', en: 'Steam Subscriber Agreement: Taxes and geographic restrictions' },
    url: 'https://store.steampowered.com/agreement/?l=english',
  },
] as const;
